import React from "react";
import Avatar from "../Avatar/Avatar";
import "./UserSuggestionDropdown.css";
import useIsMobile from "../../hooks/useIsMobile";

const UserSuggestionDropdown = ({
  users,
  onSelect,
  selectedIndex,
  isInviteWindow = false,
}) => {
  if (!users.length) return null;
  const isMobile = useIsMobile();

  if (isInviteWindow) {
    return (
      <div className="user-email-suggestion-dropdown">
        {users.map((user, index) => (
          <div
            key={user}
            className={`user-suggestion-item ${
              index === selectedIndex ? "selected" : ""
            }`}
            onClick={() => onSelect(user)}
          >
            <span className="user-suggestion-email">{user}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div
      className={
        isMobile
          ? "user-suggestion-dropdown-mobile"
          : "user-suggestion-dropdown"
      }
    >
      {users.map((user, index) => (
        <div
          key={user.userId || user.email}
          className={`user-suggestion-item ${
            index === selectedIndex ? "selected" : ""
          }`}
          onClick={() => onSelect(user)}
        >
          <Avatar user={user} name={user.email} size={24} />
          <span className="user-suggestion-email">
            {user.nickname || user.email}
          </span>
        </div>
      ))}
    </div>
  );
};

export default UserSuggestionDropdown;
